import { render, staticRenderFns } from "./EditTipologiaintervento.vue?vue&type=template&id=76bc59dc&"
import script from "./EditTipologiaintervento.vue?vue&type=script&lang=ts&"
export * from "./EditTipologiaintervento.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports